import { MenuDataLocale } from "../../menudata/types/MenuDataLocale";
import { getProcessingFeeText } from "./getProcessingFeeText";

export const getProcessingFeeDisclaimerText = (
    menuDataLocale: MenuDataLocale,
    guestPlatformFeeEnabled?: boolean | null
) =>
    `${getProcessingFeeText(menuDataLocale, undefined, {
        guestPlatformFeeEnabled,
    })} may change based on payment method.`;
